import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ValidationUtils } from '../_utils/validation.utils';

export class CustomValidators {
  static email(control: AbstractControl): ValidationErrors | null {
    const validation = ValidationUtils.validateEmail(control.value);
    return validation.valid ? null : { email: validation.message };
  }

  static username(control: AbstractControl): ValidationErrors | null {
    const validation = ValidationUtils.validateUsername(control.value);
    return validation.valid ? null : { username: validation.message };
  }

  static password(control: AbstractControl): ValidationErrors | null {
    const validation = ValidationUtils.validatePassword(control.value);
    return validation.valid ? null : { password: validation.message };
  }

  static phone(control: AbstractControl): ValidationErrors | null {
    const validation = ValidationUtils.validatePhone(control.value);
    return validation.valid ? null : { phone: validation.message };
  }

  static match(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);

      if (!control || !matchingControl) {
        return null;
      }

      if (matchingControl.errors && !matchingControl.errors['mismatch']) {
        return null;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mismatch: true });
        return { mismatch: true };
      } else {
        matchingControl.setErrors(null);
        return null;
      }
    };
  }
}